// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__28cjx","tab":"ProcedureTabs_tab__3xign"};